import script from "./NewTripPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTripPage.vue?vue&type=script&setup=true&lang=js"

import "./NewTripPage.vue?vue&type=style&index=0&id=b97f62e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b97f62e2"]])

export default __exports__